import { predicateGroupName, PredicateGroupSpec } from "../models/rules.models";

export const predicateGroups: PredicateGroupSpec[] = [
  {
    name: predicateGroupName.activity,
    label: 'Visitor\'s Activity',
    showTitle: true
  },
  {
    name: predicateGroupName.visitor,
    label: 'Visitor Properties',
    showTitle: true
  },
  {
    name: predicateGroupName.pages,
    label: 'Pages',
    showTitle: true
  },
  {
    name: predicateGroupName.sources,
    label: 'Sources that Visitor came from',
    showTitle: true
  },
  {
    name: predicateGroupName.maGeneral,
    label: 'General',
    showTitle: true
  },
  {
    name: predicateGroupName.maFields,
    label: 'Properties',
    showTitle: true
  },
  {
    name: predicateGroupName.url,
    label: 'Page Properties',
    showTitle: true
  },
  {
    name: predicateGroupName.device,
    label: 'Device Properties',
    showTitle: true
  },
  {
    name: predicateGroupName.salesforce,
    label: 'SalesForce Data',
    showTitle: true
  },
  {
    name: predicateGroupName.crmAccount,
    label: 'CRM Account Properties',
    showTitle: true
  },
  {
    name: predicateGroupName.crmOpportunity,
    label: 'CRM Opportunity Properties',
    showTitle: true
  },
  {
    name: predicateGroupName.crmLead,
    label: 'CRM Lead Properties',
    showTitle: true
  },
  {
    name: predicateGroupName.currentSession,
    label: 'Current Session',
    showTitle: true
  },
  {
    name: predicateGroupName.company,
    label: 'Company',
    showTitle: true
  },
  {
    name: predicateGroupName.visitorsActivity,
    label: 'Visitors\' Activity',
    showTitle: true
  },
  {
    name: predicateGroupName.deals,
    label: 'Deals',
    showTitle: true
  },
];
